<template>
  <div class="table-heading">
    <div
      v-for="(column, headerIndex) of columns"
      :key="headerIndex"
      v-profile-guard="column.action"
      class="table-item"
    >
      <template v-if="column.sortable">
        <a @click="sort(column.value)">
          <span>{{ column.label ? $t(column.label) : column.value }}</span>
          <span
            v-if="column.sortable"
            class="glicon-order"
            :class="{
              asc: currentSortValue === column.value && isSortAscending,
              desc: currentSortValue === column.value && !isSortAscending
            }"
          ></span>
        </a>
      </template>
      <template v-else>
        <span>{{ column.label ? $t(column.label) : column.value }}</span>
      </template>
    </div>
  </div>
</template>

<script>
import TableDatasource from './TableDatasource';

export default {
  name: 'TableHeader',
  props: {
    columns: {
      type: Array,
      default: () => []
    },
    dataSource: {
      type: Object,
      default: () => new TableDatasource()
    }
  },
  computed: {
    currentSortValue() {
      if (this.dataSource.sort) {
        return this.dataSource.sort.startsWith('-')
          ? this.dataSource.sort.substring(1)
          : this.dataSource.sort;
      }
      return null;
    },
    isSortAscending() {
      return this.dataSource.sort && this.dataSource.sort.startsWith('-') ? false : true;
    }
  },
  methods: {
    sort(field) {
      const ascendingOrder = field === this.currentSortValue ? !this.isSortAscending : true;
      this.dataSource.refresh({
        sort: `${ascendingOrder ? '' : '-'}${field}`,
        page: 1
      });
    }
  }
};
</script>
